module.exports = __webpack_public_path__ + "img/Button_Minus.b0b3cf05.png";